import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
	ApiKey,
	ApiUrl
} from "../../../util/Constant";
import ApiEngine from "../../../util/ApiEngine";
import {
	showMessage,
	showResponseMessage,
} from "../../../redux/AppAction";
import Spinner from "react-bootstrap/Spinner";
import DateRangeFilter from "components/custom/DateRangeFilter";
import PaginationBar from "../../../components/custom/PaginationBar";

const SpinWheelRecord = () => {
	let _location = useLocation();
	const _dispatch = useDispatch();
	const {t} = useTranslation();
	const [paginationPageNum, setPaginationPageNum] = useState(0);
	const [isResetCurrentPage, setIsResetCurrentPage] = useState(false);
	const [loadingFlag, setLoadingFlag] = useState(true);
	const [memberSpinList, setMemberSpinList] = useState([]);
	const [sortConfig, setSortConfig] = useState({ key: "createdDate", direction: "desc" });
  	const rewardType = useSelector((state) => state.appState.rewardType);
	const maxDate = moment();
  	const minDate = moment().subtract(1, "years");
	const [selectedOption, setSelectedOption] = useState("");

	const [startDate, setStartDate] = useState(
		_location?.state?.date
			? moment(_location.state.date.split(t("TO"))[0], "DD-MM-YYYY").locale("en")
			: moment().locale("en").startOf("isoWeek")
	);
	const [endDate, setEndDate] = useState(
		_location?.state?.date
			? moment(_location.state.date.split(t("TO"))[1], "DD-MM-YYYY").locale("en")
			: moment().locale("en").endOf("day")
	);

	const [selectedFilterType, setSelectedFilterType] = useState(
		_location?.state?.date
			? _location.state.date
			: moment().locale("en").startOf("isoWeek").format("DD-MM-YYYY") +
					t("TO") +
					moment().locale("en").endOf("day").format("DD-MM-YYYY")
	);

	
	const _STATUS_OPTIONS = [
		{ value: "AVAILABLE", label: t("AVAILABLE") },
		{ value: "COMPLETED", label: t("COMPLETED") },
		{ value: "EXPIRED", label: t("EXPIRED") },
		{ value: "CANCELLED", label: t("CANCELLED") },
		{ value: "UNAVAILABLE", label: t("UNAVAILABLE") }

	];

	const filterTypeOnSelect = (value) => {
		setSelectedFilterType(value);
	};

	useEffect(() => {
		setIsResetCurrentPage(true);
		getMemberSpinData(1);
	}, [startDate, endDate, rewardType, selectedOption, sortConfig]);


	async function getMemberSpinData(page, keyword) {
		setMemberSpinList([]);
		setLoadingFlag(true);
		try {
			page = page ? page : 1;
			const itemsPerPage = 10; 
			var start = (page - 1) * itemsPerPage;

			var apiUrl = `${
				ApiUrl._API_GET_MEMBER_REWARD_CLAIMS_RECORD +
				"?TypeId=" + rewardType.id +
				"&Status=" + selectedOption +
				"&StartDate=" +
				moment(startDate).locale("en").format("YYYY-MM-DD") +
				"&EndDate=" +
				moment(endDate).locale("en").format("YYYY-MM-DD")
			}`;

			apiUrl = apiUrl + "&start=" + start + "&count="+itemsPerPage;
			apiUrl = apiUrl + "&SortKey=" + encodeURIComponent(sortConfig.key || "");
			apiUrl = apiUrl + "&SortDirection=" + encodeURIComponent(sortConfig.direction || "");


			var responseJson = await ApiEngine.get(apiUrl);

			if (responseJson[ApiKey._API_SUCCESS_KEY]) {
				setMemberSpinList(
					responseJson[ApiKey._API_DATA_KEY][ApiKey._API_DATA_KEY]
				);

				var totalCount = responseJson[ApiKey._API_DATA_KEY].totalCount;
				updatePageinationPageNum(Math.ceil(totalCount / itemsPerPage));
			} else {
				_dispatch(
					showResponseMessage(
						responseJson[ApiKey._API_SUCCESS_KEY],
						t(responseJson[ApiKey._API_MESSAGE_KEY])
					)
				);
			}
		} catch (err) {
			
			// _dispatch(showResponseMessage(false, err.messa));
		}
		setLoadingFlag(false);
		return;
	}

	function updatePageinationPageNum(pageValue) {
		setPaginationPageNum((prevValue) => pageValue);
	}

	function toggleSort(key) {
		setSortConfig((prev) => {
			if (prev.key === key) {
				return {
					key,
					direction: prev.direction === "asc" ? "desc" : "asc",
				};
			}

			return {
				key,
				direction: "asc",
			};
		});
	}

	function getSortIcon(key) {
		const isActiveSortKey = sortConfig.key === key;
		const iconClassName = !isActiveSortKey
			? "fa fa-sort"
			: sortConfig.direction === "asc"
				? "fa fa-sort-up"
				: "fa fa-sort-down";

		return <i className={iconClassName} aria-hidden="true"></i>;
	}

	return (
		<div className="t3-downline-modal-body px-0 py-0" id="deposit-id">
			<div className="t3-statistics-dropdown-box mb-3 d-block">
				<div className="first mb-2">{t("STATUS")}</div>

				<div className="second">
				
					<select
						name="products"
						value={selectedOption}
						onChange={(e) => {
							setSelectedOption(e.target.value);
						}}
					>
						<option value="">{t("ALL")}</option>
						{_STATUS_OPTIONS.map((item, index) => {
							return (
								<option key={index} value={item.value}>
									{item.label}
								</option>
							);
						})}
					</select>
					
				</div>
			</div>
			<hr className="record-type-separator-line" />

			<DateRangeFilter
				// isOpen={isDateFilterOpen}
				startDate={startDate}
				endDate={endDate}
				setStartDate={setStartDate}
				setEndDate={setEndDate}
				onSave={(start, end) => {
					setStartDate(start);
					setEndDate(end);
				}}
				options={true}
				minDate={minDate}
				maxDate={maxDate}
				initialType={selectedFilterType}
				// onClose={dateRangePickerOnClose}
				typeOnSelect={filterTypeOnSelect}
			/>


			<div className="t3-downline-table-body">
				<div className="t3-table-container">
					<table className="t3-custom-table">
						<thead>
							<tr>
								<th>{t("ID")}</th>
								<th>{t("CAMPAIGN")}</th>
								<th
									style={{ userSelect: "none" }}
								>
									<span>{t("CREATED_DATE")}</span>
									<button
										className="btn btn-sort"
										type="button"
										onClick={() => toggleSort("createdDate")}
										aria-label={`${t("CREATED_DATE")} sort`}
									>
										{getSortIcon("createdDate")}
									</button>
								</th>
								<th
									style={{ userSelect: "none" }}
								>
									<span>{t("STATUS")}</span>
									<button
										className="btn btn-sort"
										type="button"
										onClick={() => toggleSort("status")}
										aria-label={`${t("STATUS")} sort`}
									>
										{getSortIcon("status")}
									</button>
								</th>
								<th
									style={{ userSelect: "none" }}
								>
									<span>{t("CLAIMED_DATE")}</span>
									<button
										className="btn btn-sort"
										type="button"
										onClick={() => toggleSort("claimedDateTxt")}
										aria-label={`${t("CLAIMED_DATE")} sort`}

									>
										{getSortIcon("claimedDateTxt")}
									</button>
								</th>
								<th>{t("REWARD")}</th>
							</tr>
						</thead>
						<tbody>
							{memberSpinList &&
							memberSpinList.length != 0 ? (
								memberSpinList.map((data, index) => {

									return (
										<tr key={index}>
											<td>
												{data["id"]}
											</td>
											<td>
											   {data["campaignName"]}
											</td>
											<td>
											   {moment(data["createdDate"]).locale("en").format("DD-MM-yyyy HH:mm:ss")}
											</td>
											<td className={data["status"] === "AVAILABLE" || data["status"] === "COMPLETED" ? "claimedTxt-success" : "claimedTxt-expired"}>
											   {t(data["status"])}
											</td>
											<td>										   
											   {data["claimedDateTxt"]}
									
											</td>
											<td>
												{data["reward"]}
											</td>
										</tr>
									);
								})
							) : loadingFlag ? (
								<tr>
									<td colSpan={6}>
										<div
											style={{
												textAlign: "center",
												marginTop: "25px",
												marginBottom: "20px",
											}}
										>
											<Spinner
												animation="border"
												role="status"
												size="sm"
												style={{
													verticalAlign: "middle",
													width: "2rem",
													height: "2rem",
												}}
											>
												<span className="sr-only">{t("LOADING")}...</span>
											</Spinner>
										</div>
									</td>
								</tr>
							) : (
								<tr>
									<td colSpan={6}>{t("NO_DATA_FOUND")}</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>
			{paginationPageNum > 1 && (
				<PaginationBar
					totalPages={paginationPageNum}
					retrieveDataRecords={getMemberSpinData}
					isResetCurrentPage={isResetCurrentPage}
					setIsChangeTab={setIsResetCurrentPage}
				/>
			)}
		</div>
	);
};

export default SpinWheelRecord ;
